import type { RegisterOptions } from "react-hook-form";

type NameValidationRuleKeys = "name" | "nameKana";

type NameValidationRule = {
  [key in NameValidationRuleKeys]: RegisterOptions;
};

export const inputRequiredMessage = "入力必須";

export const nameRegexPattern =
  /^[\x21-\x7e\u2E80-\u2FD5\u3005\u3041-\u309E\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCB\uF900-\uFA6A]+$/;
export const nameKanaRegexPattern = /^[\u3041-\u309E]+$/;

export const nameValidation: NameValidationRule = {
  name: {
    pattern: {
      // ASCII, Hiragana, Katakana, Kanji, Kanji Radicalsのみ許可する正規表現 + 々(Unicode 3005)
      // 参考：https://www.localizingjapan.com/blog/2012/01/20/regular-expressions-for-japanese-text/
      value: nameRegexPattern,
      message:
        "漢字・ひらがな・カタカナ・半角英数字のいずれかで入力してください",
    },
    maxLength: {
      value: 30,
      message: "30文字以内で入力してください",
    },
  },
  nameKana: {
    pattern: {
      // Hiraganaのみ許可する正規表現
      value: nameKanaRegexPattern,
      message: "ひらがなのみで入力してください",
    },
    maxLength: {
      value: 30,
      message: "30文字以内で入力してください",
    },
  },
};
